module.exports = __webpack_public_path__ + "static/key-theshapeshiftingdetective-6580091513d6fa6a1ac31b797c5f8f3c.webp";